module.exports = __webpack_public_path__ + "img/calm-03012025.346691a0.jpg";